import { selectStandardProps } from "@/utils/componentUtils";
import { validations } from "@/utils/validationUtils";
import { Checkbox, Col, Form, Select } from "antd";
import { useTranslation } from "react-i18next";
import { VehiclePurpose } from "../../../../../../calculator/calcs/vehicle/enums";

const colSpan = 4;

type Props = {
  formNameDataPrefix: (string | number)[];
  index: number;
};

export const StandardVehicleInsuranceFormPart = ({ formNameDataPrefix, index }: Props) => {
  const { t } = useTranslation();

  const form = Form.useFormInstance();

  const handleLeasingChange = () => {
    const insurances = form.getFieldValue(["insurances"]) ?? [];
    insurances[index] = { ...insurances[index], vehicleOwnerIdentifier: undefined };
    form.setFieldsValue({ insurances });
  };

  return (
    <>
      <Col span={colSpan}>
        <Form.Item
          name={[...formNameDataPrefix, "purpose"]}
          label={t("calc.vehicle.enums.vehiclePurpose._label")}
          rules={[validations.notNull]}
        >
          <Select
            {...selectStandardProps}
            options={Object.keys(VehiclePurpose).map((purpose) => ({
              value: purpose,
              label: t("calc.vehicle.enums.vehiclePurpose." + purpose),
            }))}
          />
        </Form.Item>
      </Col>

      <Col span={colSpan}>
        <Form.Item
          name={[...formNameDataPrefix, "leasing"]}
          valuePropName="checked"
          rules={[validations.none]}
          initialValue={false}
          className="form-item-without-label"
        >
          <Checkbox onChange={handleLeasingChange}>{t("contract.attrs.insurances.insuranceData.leasing")}</Checkbox>
        </Form.Item>
      </Col>
    </>
  );
};
